export default function TempsSynopsis(){
  return(
    <div>
      Template Synopsis coming soon!
    </div>
  );
}